import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { ArrowRight, BookOpen } from 'lucide-react';

export function DocServicesPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['service-definitions-docs'],
    queryFn: () => api.get('/api/services/definition/list').then((r: any) => r.data),
  });

  const definitions = data?.query?.data ?? [];

  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <BookOpen className="h-6 w-6" /> Service Documentation
        </h1>
        <p className="text-gray-500">Learn about available service integrations and processors</p>
      </div>

      {isLoading ? (
        <div className="text-center py-12 text-gray-500">Loading documentation...</div>
      ) : (
        <div className="space-y-4">
          {definitions.map((def: any) => (
            <Card key={def.service_definition_id}>
              <CardHeader>
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-sm font-medium">{def.source_app_name}</span>
                  <ArrowRight className="h-4 w-4 text-gray-400" />
                  <span className="text-sm font-medium">{def.target_app_name}</span>
                </div>
                <CardTitle className="text-lg">{def.service_definition_name}</CardTitle>
                {def.description && <CardDescription>{def.description}</CardDescription>}
              </CardHeader>
              <CardContent>
                <div className="flex items-center gap-2">
                  <Badge variant="secondary">
                    {def.processor_count ?? 0} processor(s)
                  </Badge>
                  {def.auth_type && (
                    <Badge variant="outline">{def.auth_type}</Badge>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}